import { getHistoryService } from 'src/services/sharedRuntime';
import office from 'src/services/office';
import { FlowstepCategory } from 'shared/utils/flowstep';
import { runCancelableAction } from 'src/services/utils';
import { officeStore, userStore } from 'src/stores/index';
import { autorun } from 'mobx';
import { capitalizeString, isTestStage } from '../../../../shared/utils/utils';

//TODO: Remove unused routes, after manifest update
const routes = {
  'Xappex.Taskpane.Btn.Home': '/home',
  'Xappex.Taskpane.Btn.Flows': '/home/flows',
  'Xappex.Taskpane.Btn.Scheduler': '/home/scheduler',
  'Xappex.Taskpane.Btn.Context': '/home/context',
  'Xappex.Taskpane.Btn.Schedules': '/schedules',
  'Xappex.Taskpane.Btn.Settings': '/settings',
  'Xappex.Taskpane.Btn.About': '/about',
}

const ButtonId = {
  Refresh: 'Xappex.Taskpane.Btn.Rfrsh',
  RefreshAll: 'Xappex.Taskpane.Btn.RfrshAll',
}

async function showTaskpane() {
  await Promise.all([
    Office.addin.showAsTaskpane(),
    office.setVisibilityMode(true),
  ]);
}

async function updateAuthRequiredButtons(buttons) {
  try {
    const id = `Xappex.${isTestStage(STAGE) ? capitalizeString(STAGE) + '.' : ''}MainTab`
    await Office.ribbon.requestUpdate({
      tabs: [
        {
          id,
          groups: [
            {
              id: "Xappex.MainTab.Group2",
              controls: buttons
            }
          ]
        }
      ]
    });
  }
  catch (err) {
    //skip error if manifest is outdated
  }

}


async function command_Navigate({ source, completed }) {
  console.debug('Excel365: command_Navigate');

  await showTaskpane();

  const route = routes[source.id];
  if (route) {
    const history = await getHistoryService();
    history?.push(route);
  }

  completed();
  console.log('Excel365: command_Navigate completed');
}

async function command_Show({ completed }) {
  console.debug('Excel365: command_Show');

  await showTaskpane();

  completed();
  console.log('Excel365: command_Show completed');
}

async function command_Refresh({ completed }) {
  console.debug('Excel365: command_Refresh');

  if (userStore.isAuthorized) {
    await showTaskpane();
    await runCancelableAction(async (token) => await officeStore.refreshCurrentSheet(FlowstepCategory.Pull, token));
  }

  completed();
  console.log('Excel365: command_Refresh completed');
}

async function command_RefreshAll({ completed }) {
  console.debug('Excel365: command_RefreshAll');

  if (userStore.isAuthorized) {
    await showTaskpane();
    await runCancelableAction(async (token) => await officeStore.refreshAllSheets(FlowstepCategory.Pull, token));
  }

  completed();

  console.log('Excel365: command_RefreshAll completed');
}


const commands = {
  command_Show, command_Navigate, command_Refresh, command_RefreshAll
}

console.log(`Excel365 (${STAGE}): commands initializing`);
Object.entries(commands).forEach(([name, fun]) => Office.actions.associate(name, fun));

Office.onReady().then(() => {
  autorun(async () => {
    const isAuthorized = userStore.isAuthorized;
    const canRefresh = userStore.license.flowsteps.pull.seeRefreshButton.can || false;
    const canRunAll = userStore.license.flowsteps.pull.runAll.can || false;
    
    await updateAuthRequiredButtons([{
      id: ButtonId.Refresh,
      enabled: isAuthorized && canRefresh
    }, {
      id: ButtonId.RefreshAll,
      enabled: isAuthorized && canRefresh && canRunAll
    }]);
  });
});
